"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2394],{

/***/ 77427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* reexport */ Accordion_Accordion; },
  "Q": function() { return /* reexport */ AccordionItem_AccordionItem; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/@next/components/atoms/Accordion/Context.ts
/* eslint-disable @typescript-eslint/no-empty-function */ 
var initialContext = {
    keys: [],
    setKeys: function() {},
    handleToggle: function() {},
    expanded: [],
    disabled: []
};
var AccordionContext = react.createContext(initialContext);
/* harmony default export */ var Context = (AccordionContext);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
;// CONCATENATED MODULE: ./src/@next/components/atoms/Accordion/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 83vw;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &.disabled > button {\n    color: ",
        ";\n    cursor: default;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      height: 20px;\n      right: 9px;\n      margin-top: -10px;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      height: 12px;\n      right: 5px;\n      margin-top: -6px;\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      width: 20px;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      width: 12px;\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      color: ",
        ";\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  transition: color 0.8s;\n  font-size: ",
        ";\n  font-family: ",
        ";\n  line-height: 1.1em;\n  display: block;\n  padding: ",
        ";\n  position: relative;\n  width: 100%;\n  text-align: left;\n\n  &:before,\n  &:after {\n    content: '';\n    display: block;\n    position: absolute;\n    background-color: ",
        ";\n    transition: background-color 0.6s, opacity 0.4s, transform 0.4s;\n  }\n  &:before {\n    width: 2px;\n    height: 24px;\n    top: 50%;\n    margin-top: -12px;\n    right: 11px;\n    ",
        "\n    ",
        "\n  }\n  &:after {\n    height: 2px;\n    width: 24px;\n    top: 50%;\n    margin-top: -1px;\n    right: 0;\n    ",
        "\n    ",
        "\n  }\n  * {\n    font: inherit;\n    line-height: inherit;\n    color: inherit;\n  }\n  &:hover {\n    color: ",
        ";\n    ",
        "\n  }\n  &.expanded {\n    color: ",
        ";\n    &:after {\n      background-color: ",
        ";\n    }\n    &:before {\n      transform: rotate(90deg);\n      opacity: 0;\n      background-color: $red;\n    }\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  transition: max-height 0.8s;\n  will-change: max-height;\n  font-size: ",
        ";\n  font-family: ",
        ";\n  line-height: 1.6em;\n  &.collapsed {\n    overflow: hidden;\n    max-height: 0;\n    transition: all 0.5s cubic-bezier(0, 1, 0.3, 1) -100ms;\n  }\n  &.expanded {\n    max-height: 2000px;\n    transition: all 0.5s cubic-bezier(1, 0.15, 1, 1);\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}

var Accordion = globalStyles/* styled.div */.zo.div(_templateObject1(), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject()));
var AccordionItem = globalStyles/* styled.div */.zo.div(_templateObject2(), function(props) {
    return props.theme.colors.disabled;
});
var Header = globalStyles/* styled.button */.zo.button(_templateObject8(), function(props) {
    return props.theme.colors.baseFontColorOpacityLight;
}, function(props) {
    return props.theme.typography.h3FontSize;
}, function(props) {
    return props.theme.typography.thinFontFamily;
}, function(param) {
    var spacing = param.theme.spacing;
    return "".concat(spacing.spacer, " ").concat(spacing.spacer, " ").concat(spacing.spacer, " 0");
}, function(props) {
    return props.theme.colors.blueLight;
}, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject3()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject4()), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject5()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject6()), function(props) {
    return props.theme.colors.baseFont;
}, globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject7(), function(props) {
    return props.theme.colors.baseFontColorOpacityLight;
}), function(props) {
    return props.theme.colors.red;
}, function(props) {
    return props.theme.colors.red;
});
var Body = globalStyles/* styled.div */.zo.div(_templateObject9(), function(props) {
    return props.theme.typography.baseFontSize;
}, function(props) {
    return props.theme.typography.extraFontFamily;
});

;// CONCATENATED MODULE: ./src/@next/components/atoms/Accordion/Accordion.tsx






var Accordion_Accordion = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    var _expanded;
    var _$ref = (0,_sliced_to_array/* default */.Z)(react.useState((_expanded = props.expanded) !== null && _expanded !== void 0 ? _expanded : []), 2), expanded = _$ref[0], setExpanded = _$ref[1];
    var _$ref1 = (0,_sliced_to_array/* default */.Z)(react.useState([]), 2), keys = _$ref1[0], setKeys = _$ref1[1];
    var handleAllState = function(state) {
        if (state) {
            var items = [];
            keys.forEach(function(key) {
                return !(props.disabled && props.disabled.includes(key)) && items.push(key);
            });
            setExpanded(items);
        } else {
            setExpanded([]);
        }
    };
    var handleState = function(state, uniqueKey) {
        var index = expanded.indexOf(uniqueKey);
        var newKeys = (0,_to_consumable_array/* default */.Z)(expanded);
        if (index > -1 && !state) {
            newKeys.splice(index, 1);
        }
        if (index < 0 && state) {
            newKeys.push(uniqueKey);
        }
        setExpanded(newKeys);
    };
    var handleToggle = function(uniqueKey) {
        var _$ref;
        if (!((_$ref = props.disabled) === null || _$ref === void 0 ? void 0 : _$ref.includes(uniqueKey))) {
            var index = expanded.indexOf(uniqueKey);
            if (props.multi) {
                var newKeys = (0,_to_consumable_array/* default */.Z)(expanded);
                if (index > -1) {
                    newKeys.splice(index, 1);
                } else {
                    newKeys.push(uniqueKey);
                }
                setExpanded(newKeys);
            } else if (index > -1) {
                setExpanded([]);
            } else {
                setExpanded([
                    uniqueKey
                ]);
            }
        }
    };
    react.useImperativeHandle(ref, function() {
        return {
            openAll: function openAll() {
                handleAllState(true);
            },
            closeAll: function closeAll() {
                handleAllState(false);
            },
            open: function open(uniqueKey) {
                handleState(true, uniqueKey);
            },
            close: function close(uniqueKey) {
                handleState(false, uniqueKey);
            },
            toggle: function toggle(uniqueKey) {
                handleToggle(uniqueKey);
            }
        };
    }, [
        expanded,
        keys,
        props.disabled
    ]);
    var _disabled;
    var ProviderValue = (0,react.useMemo)(function() {
        return {
            expanded: expanded,
            setKeys: setKeys,
            keys: keys,
            handleToggle: handleToggle,
            disabled: (_disabled = props.disabled) !== null && _disabled !== void 0 ? _disabled : []
        };
    }, [
        expanded,
        setKeys,
        keys,
        handleToggle,
        props.disabled
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Context.Provider, {
        value: ProviderValue,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion, {
            className: props.className,
            children: props.children
        })
    });
});
Accordion_Accordion.displayName = "Accordion";

;// CONCATENATED MODULE: ./src/@next/components/atoms/Accordion/AccordionItem.tsx





var AccordionItem_AccordionItem = function(param) {
    var title = param.title, uniqueKey = param.uniqueKey, children = param.children;
    var ref = (0,react.useContext)(Context), expanded = ref.expanded, disabled = ref.disabled, handleToggle = ref.handleToggle, keys = ref.keys, setKeys = ref.setKeys;
    (0,react.useEffect)(function() {
        setKeys((0,_to_consumable_array/* default */.Z)(keys).concat([
            uniqueKey
        ]));
    }, []);
    var state = {
        expanded: expanded.includes(uniqueKey),
        disabled: disabled.includes(uniqueKey)
    };
    var cssStyle = [];
    cssStyle.push(state.expanded ? "expanded" : "collapsed");
    cssStyle.push(state.disabled ? "disabled" : "");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AccordionItem, {
        className: cssStyle.join(" "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                type: "button",
                onClick: function() {
                    return handleToggle(uniqueKey);
                },
                className: cssStyle.join(" "),
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Body, {
                className: state.expanded ? "expanded" : "collapsed",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "item-body",
                    children: children
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/@next/components/atoms/Accordion/index.ts




/***/ }),

/***/ 95476:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* reexport */ Breadcrumbs_Breadcrumbs; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
// EXTERNAL MODULE: ./node_modules/next-translate-routes/link.js
var next_translate_routes_link = __webpack_require__(73966);
var link_default = /*#__PURE__*/__webpack_require__.n(next_translate_routes_link);
// EXTERNAL MODULE: ./src/@next/hooks/useMediaQuery/index.ts + 3 modules
var useMediaQuery = __webpack_require__(15996);
// EXTERNAL MODULE: ./src/@next/globalStyles/constants.ts
var constants = __webpack_require__(38408);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
;// CONCATENATED MODULE: ./src/images/breadcrumbs-arrow.svg
var breadcrumbs_arrow_namespaceObject = __webpack_require__.p + "static/images/breadcrumbs-arrow.svg";
;// CONCATENATED MODULE: ./src/@next/components/molecules/Breadcrumbs/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 21px 62px;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 20px 31px;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 10px 16px;\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-flex;\n  flex-wrap: wrap;\n  margin: 24px 62px;\n  font-family: ",
        ";\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-transform: capitalize;\n  opacity: ",
        ";\n  transition: opacity 0.25s ease-in-out;\n\n  &:not(:last-of-type) {\n    &:after {\n      content: url(",
        ");\n      display: inline-block;\n      margin: 0 calc(",
        " / 2);\n    }\n  }\n\n  a {\n    color: ",
        ";\n    font-weight: ",
        ";\n    text-decoration: none;\n    vertical-align: middle;\n    transition: 0.3s;\n    font-size: ",
        ";\n\n    &:hover,\n    &:focus {\n      opacity: 1;\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var Wrapper = globalStyles/* styled.div */.zo.div(_templateObject());
var Breadcrumbs = globalStyles/* styled.ul */.zo.ul(_templateObject4(), function(props) {
    return props.theme.typography.thinFontFamily;
}, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject1()), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject2()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject3()));
var Item = globalStyles/* styled.li */.zo.li(_templateObject5(), function(props) {
    return props.active ? 1 : 0.5;
}, breadcrumbs_arrow_namespaceObject, function(props) {
    return props.theme.spacing.spacer;
}, function(props) {
    return props.theme.colors.lightFont;
}, function(props) {
    return props.active ? props.theme.typography.boldFontWeight : undefined;
}, function(props) {
    return props.theme.typography.smallFontSize;
}, function(props) {
    return props.theme.colors.red;
});

// EXTERNAL MODULE: ./src/paths.ts
var paths = __webpack_require__(4032);
;// CONCATENATED MODULE: ./src/@next/components/molecules/Breadcrumbs/BreadcrumbList.tsx






var BreadcrumbList = function(param) {
    var breadcrumbs = param.breadcrumbs, _showHomeLink = param.showHomeLink, showHomeLink = _showHomeLink === void 0 ? true : _showHomeLink;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumbs, {
        children: [
            showHomeLink && /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                active: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: paths/* paths.home */.H.home,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                            defaultMessage: "Home",
                            id: "ejEGdx"
                        })
                    })
                })
            }),
            breadcrumbs.map(function(breadcrumb, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                    active: index === breadcrumbs.length - 1,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: breadcrumb.link,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            children: breadcrumb.value
                        })
                    })
                }, "".concat(breadcrumb.value, "-").concat(index));
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/@next/components/molecules/Breadcrumbs/Breadcrumbs.tsx









var getBackLink = function(breadcrumbs) {
    return breadcrumbs.length > 1 ? breadcrumbs[breadcrumbs.length - 2].link : "/";
};
var Breadcrumbs_Breadcrumbs = function(param) {
    var breadcrumbs = param.breadcrumbs, _useMediaQueries = param.useMediaQueries, useMediaQueries = _useMediaQueries === void 0 ? true : _useMediaQueries, _showHomeLink = param.showHomeLink, showHomeLink = _showHomeLink === void 0 ? true : _showHomeLink;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useMediaQuery/* useMediaQuery */.a)("(max-width: ".concat(constants/* xSmallScreen */.zk, "px)")), 1), isSmallScreen = ref[0];
    if (!useMediaQueries) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadcrumbList, {
            breadcrumbs: breadcrumbs,
            showHomeLink: showHomeLink
        });
    }
    return isSmallScreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadcrumbList, {
        breadcrumbs: breadcrumbs,
        showHomeLink: showHomeLink
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: getBackLink(breadcrumbs),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                    defaultMessage: "Back",
                    id: "cyR7Kh"
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/@next/components/molecules/Breadcrumbs/index.ts



/***/ }),

/***/ 87226:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "C": function() { return /* reexport */ SliceAccordion; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@prismicio/react/dist/PrismicRichText.js + 16 modules
var PrismicRichText = __webpack_require__(50385);
// EXTERNAL MODULE: ./src/@next/components/atoms/Accordion/index.ts + 4 modules
var Accordion = __webpack_require__(77427);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
// EXTERNAL MODULE: ./src/@next/components/templates/Container/index.ts
var Container = __webpack_require__(95213);
// EXTERNAL MODULE: ./src/@next/globalStyles/utils.ts + 1 modules
var utils = __webpack_require__(44610);
;// CONCATENATED MODULE: ./src/@next/components/slices/SliceAccordion/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      display: block;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &-container {\n    display: flex;\n    ",
        "\n  }\n\n  &-column {\n    width: 100%;\n    &:not(:last-child) {\n      margin-right: 40px;\n    }\n  }\n\n  * {\n    line-height: inherit;\n  }\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var Wrapper = (0,globalStyles/* styled */.zo)(Container/* Container */.W2)(_templateObject());
var ContentWrapper = globalStyles/* styled.div */.zo.div(_templateObject2(), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject1()), utils/* prismicRichText */.C7);

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceAccordion/SliceAccordion.tsx




function SliceAccordion(param) {
    var fields = param.slice.fields;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        className: "slice-item slice-accordion",
        children: fields && /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* Accordion */.U, {
            multi: true,
            children: fields.map(function(item, i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* AccordionItem */.Q, {
                    title: item.title,
                    uniqueKey: i,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentWrapper, {
                        className: "list-content",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "list-content-container",
                            children: item.rich_text && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "list-content-column",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                                    field: item.rich_text
                                })
                            })
                        })
                    })
                }, "slice-accordion-item-".concat(i));
            })
        })
    });
}
SliceAccordion.componentName = "accordion";

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceAccordion/index.tsx



/***/ }),

/***/ 30513:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "F": function() { return /* reexport */ SliceBlogContentPhotoPhoto; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/@prismic/components/PrismicNextImage/index.ts + 3 modules
var PrismicNextImage = __webpack_require__(32243);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
// EXTERNAL MODULE: ./src/@next/components/templates/Container/index.ts
var Container = __webpack_require__(95213);
// EXTERNAL MODULE: ./src/@next/globalStyles/utils.ts + 1 modules
var utils = __webpack_require__(44610);
;// CONCATENATED MODULE: ./src/@next/components/slices/SliceBlogContentPhotoPhoto/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: block;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n\n    &:nth-of-type(1) {\n      margin-right: 0;\n    }\n\n    &:nth-of-type(2) {\n      margin-top: 40px;\n      margin-left: 0;\n    }\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: calc(50% - 20px);\n\n  &:nth-of-type(1) {\n    margin-right: 20px;\n  }\n\n  &:nth-of-type(2) {\n    margin-left: 20px;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var Wrapper = (0,globalStyles/* styled */.zo)(Container/* Container */.W2)(_templateObject1(), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject()), utils/* prismicRichText */.C7);
var Photo = globalStyles/* styled.div */.zo.div(_templateObject3(), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject2()));

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceBlogContentPhotoPhoto/SliceBlogContentPhotoPhoto.tsx




function SliceBlogContentPhotoPhoto(param) {
    var fields = param.slice.fields;
    var renderContent = fields ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        className: "slice-item blog-photo-photo",
        children: fields.map(function(item, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Photo, {
                        className: "blog-photo-photo__photo",
                        children: item.content_photo_left && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: item.photo_left_link ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: item.photo_left_link,
                                target: "_blank",
                                rel: "noreferrer",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicNextImage/* PrismicNextImage */.Z, {
                                    field: item.content_photo_left,
                                    style: {
                                        maxWidth: "100%",
                                        height: "100%"
                                    }
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicNextImage/* PrismicNextImage */.Z, {
                                field: item.content_photo_left,
                                style: {
                                    maxWidth: "100%",
                                    height: "100%"
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Photo, {
                        className: "blog-photo-photo__photo",
                        children: item.content_photo_right && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: item.photo_right_link ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: item.photo_right_link,
                                target: "_blank",
                                rel: "noreferrer",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicNextImage/* PrismicNextImage */.Z, {
                                    field: item.content_photo_right,
                                    style: {
                                        maxWidth: "100%",
                                        height: "100%"
                                    }
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicNextImage/* PrismicNextImage */.Z, {
                                field: item.content_photo_right,
                                style: {
                                    maxWidth: "100%",
                                    height: "100%"
                                }
                            })
                        })
                    })
                ]
            }, i);
        })
    }) : null;
    return renderContent;
}
SliceBlogContentPhotoPhoto.componentName = "blog-photo-photo";

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceBlogContentPhotoPhoto/index.tsx



/***/ }),

/***/ 84648:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": function() { return /* reexport */ SliceBlogContentTextPhoto; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/@prismicio/react/dist/PrismicRichText.js + 16 modules
var PrismicRichText = __webpack_require__(50385);
// EXTERNAL MODULE: ./src/@prismic/components/PrismicNextImage/index.ts + 3 modules
var PrismicNextImage = __webpack_require__(32243);
// EXTERNAL MODULE: ./src/@next/utils/core.ts + 1 modules
var core = __webpack_require__(62823);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
// EXTERNAL MODULE: ./src/@next/components/templates/Container/index.ts
var Container = __webpack_require__(95213);
// EXTERNAL MODULE: ./src/@next/globalStyles/utils.ts + 1 modules
var utils = __webpack_require__(44610);
;// CONCATENATED MODULE: ./src/@next/components/slices/SliceBlogContentTextPhoto/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: block;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    margin: 0;\n    margin-bottom: 40px;\n\n    &.reversed {\n      margin: 0;\n      margin-bottom: 0;\n    }\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: calc(66% - 20px);\n  margin-right: 20px;\n\n  &.full-width {\n    width: 100%;\n  }\n\n  &.empty-width {\n    width: 0%;\n  }\n\n  &.reversed {\n    margin-right: 0;\n    margin-left: 20px;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    margin: 0;\n    margin-bottom: 0;\n\n    &.reversed {\n      margin: 0;\n      margin-bottom: 40px;\n    }\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: calc(33% - 20px);\n  margin-left: 20px;\n\n  & > div {\n    display: flex;\n    justify-content: center;\n  }\n\n  &.full-width {\n    width: 100%;\n  }\n\n  &.empty-width {\n    width: 0%;\n  }\n\n  &.reversed {\n    margin-left: 0;\n    margin-right: 20px;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}



var Wrapper = (0,globalStyles/* styled */.zo)(Container/* Container */.W2)(_templateObject1(), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject()), utils/* prismicRichText */.C7);
var Paragraph = globalStyles/* styled.div */.zo.div(_templateObject3(), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject2()));
var Photo = globalStyles/* styled.div */.zo.div(_templateObject5(), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject4()));

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceBlogContentTextPhoto/SliceBlogContentTextPhoto.tsx






function SliceBlogContentTextPhoto(param) {
    var fields = param.slice.fields;
    var fieldsMaybe = fields && fields[0];
    var reverseMaybe = fieldsMaybe && fieldsMaybe.__typename && fieldsMaybe.__typename === "Blog_postBodyContent_photo_text_30_60Fields";
    var renderFields = fieldsMaybe ? [
        /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
            className: (0,clsx/* clsx */.W)({
                "blog-text-photo__paragraph": true,
                "empty-width": fieldsMaybe && !fieldsMaybe.content_text,
                "full-width": fieldsMaybe && !fieldsMaybe.content_photo,
                reversed: reverseMaybe
            }),
            children: fieldsMaybe.content_text && /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                field: fieldsMaybe.content_text
            })
        }, (0,core/* generateKey */.HI)(fieldsMaybe.content_text.slice(0, 9), "blog-text-photo__paragraph")),
        /*#__PURE__*/ (0,jsx_runtime.jsx)(Photo, {
            className: (0,clsx/* clsx */.W)({
                "blog-text-photo__photo": true,
                "empty-width": fieldsMaybe && !fieldsMaybe.content_photo,
                "full-width": fieldsMaybe && !fieldsMaybe.content_text,
                reversed: reverseMaybe
            }),
            children: fieldsMaybe.content_photo && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: fieldsMaybe.photo_link ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: fieldsMaybe.photo_link,
                    target: "_blank",
                    rel: "noreferrer",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicNextImage/* PrismicNextImage */.Z, {
                        field: fieldsMaybe.content_photo,
                        style: {
                            maxWidth: "100%",
                            height: "100%"
                        }
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicNextImage/* PrismicNextImage */.Z, {
                    field: fieldsMaybe.content_photo,
                    style: {
                        maxWidth: "100%",
                        height: "100%"
                    }
                })
            })
        }, (0,core/* generateKey */.HI)(fieldsMaybe.content_text.slice(0, 9), "blog-text-photo__photo")), 
    ] : [];
    var renderContent = fieldsMaybe ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        className: "slice-item blog-text-photo",
        children: reverseMaybe ? renderFields.reverse() : renderFields
    }) : null;
    return renderContent;
}
SliceBlogContentTextPhoto.componentName = "blog-content-text-photo";

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceBlogContentTextPhoto/index.tsx



/***/ }),

/***/ 85370:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* reexport */ SliceBlogContentTextText; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@prismicio/react/dist/PrismicRichText.js + 16 modules
var PrismicRichText = __webpack_require__(50385);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
// EXTERNAL MODULE: ./src/@next/components/templates/Container/index.ts
var Container = __webpack_require__(95213);
// EXTERNAL MODULE: ./src/@next/globalStyles/utils.ts + 1 modules
var utils = __webpack_require__(44610);
;// CONCATENATED MODULE: ./src/@next/components/slices/SliceBlogContentTextText/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: block;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n\n    &:nth-of-type(1) {\n      margin-right: 0;\n    }\n\n    &:nth-of-type(2) {\n      margin-left: 0;\n      margin-top: 40px;\n    }\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: calc(50% - 20px);\n\n  &:nth-of-type(1) {\n    margin-right: 20px;\n  }\n\n  &:nth-of-type(2) {\n    margin-left: 20px;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var Wrapper = (0,globalStyles/* styled */.zo)(Container/* Container */.W2)(_templateObject1(), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject()), utils/* prismicRichText */.C7);
var Paragraph = globalStyles/* styled.div */.zo.div(_templateObject3(), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject2()));

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceBlogContentTextText/SliceBlogContentTextText.tsx




function SliceBlogContentTextText(param) {
    var fields = param.slice.fields;
    var renderContent = fields ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        className: "slice-item blog-text-text",
        children: fields.map(function(item, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                        className: "blog-text-text__paragraph",
                        children: item.content_text_left && /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                            field: item.content_text_left
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                        className: "blog-text-text__paragraph",
                        children: item.content_text_right && /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                            field: item.content_text_right
                        })
                    })
                ]
            }, i);
        })
    }) : null;
    return renderContent;
}
SliceBlogContentTextText.componentName = "blog-content-text-text";

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceBlogContentTextText/index.tsx



/***/ }),

/***/ 83147:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w": function() { return /* reexport */ SliceContentPhotoPhoto; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/@prismic/components/PrismicNextImage/index.ts + 3 modules
var PrismicNextImage = __webpack_require__(32243);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
// EXTERNAL MODULE: ./src/@next/components/templates/Container/index.ts
var Container = __webpack_require__(95213);
// EXTERNAL MODULE: ./src/@next/globalStyles/utils.ts + 1 modules
var utils = __webpack_require__(44610);
;// CONCATENATED MODULE: ./src/@next/components/slices/SliceContentPhotoPhoto/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: block;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    padding-right: 0;\n    padding-left: 0;\n    padding-top: 1rem;\n    padding-botton: 1rem;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  padding-left: 1rem;\n  padding-right: 1rem;\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var Wrapper = (0,globalStyles/* styled */.zo)(Container/* Container */.W2)(_templateObject1(), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject()), utils/* prismicRichText */.C7);
var Photo = globalStyles/* styled.div */.zo.div(_templateObject3(), function(param) {
    var count = param.count;
    return "calc(100% / ".concat(count, ")");
}, globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject2()));

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceContentPhotoPhoto/SliceContentPhotoPhoto.tsx




function SliceContentPhotoPhoto(param) {
    var fields = param.slice.fields;
    var count = fields.length;
    var renderContent = fields ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        className: "slice-item content-photo-photo",
        children: fields.map(function(item, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                children: item.content_photo && /*#__PURE__*/ (0,jsx_runtime.jsx)(Photo, {
                    count: count,
                    children: item.photo_link ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: item.photo_link,
                        target: "_blank",
                        rel: "noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicNextImage/* PrismicNextImage */.Z, {
                            field: item.content_photo,
                            style: {
                                maxWidth: "100%",
                                height: "100%"
                            }
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicNextImage/* PrismicNextImage */.Z, {
                        field: item.content_photo,
                        style: {
                            maxWidth: "100%",
                            height: "100%"
                        }
                    })
                })
            }, i);
        })
    }) : null;
    return renderContent;
}
SliceContentPhotoPhoto.componentName = "content-photo-photo";

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceContentPhotoPhoto/index.tsx



/***/ }),

/***/ 88727:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D": function() { return /* reexport */ SliceContentPhotoText; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@prismicio/react/dist/PrismicRichText.js + 16 modules
var PrismicRichText = __webpack_require__(50385);
// EXTERNAL MODULE: ./src/@prismic/components/PrismicNextImage/index.ts + 3 modules
var PrismicNextImage = __webpack_require__(32243);
// EXTERNAL MODULE: ./src/@next/utils/core.ts + 1 modules
var core = __webpack_require__(62823);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
// EXTERNAL MODULE: ./src/@next/components/templates/Container/index.ts
var Container = __webpack_require__(95213);
// EXTERNAL MODULE: ./src/@next/globalStyles/utils.ts + 1 modules
var utils = __webpack_require__(44610);
;// CONCATENATED MODULE: ./src/@next/components/slices/SliceContentPhotoText/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 2em 2em;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex-direction: column;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: ",
        ";\n  justify-content: space-between;\n  align-items: center;\n  ",
        "\n  overflow: hidden;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 2em 2em;\n  width: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  img {\n    width: 100%;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  height: 100%;\n  padding-left: 1rem;\n  padding-right: 1rem;\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}



var Wrapper = globalStyles/* styled.div */.zo.div(_templateObject());
var styles_Container = (0,globalStyles/* styled */.zo)(Container/* Container */.W2)(_templateObject2(), function(param) {
    var reverse = param.reverse;
    return reverse ? "row" : "row-reverse";
}, globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject1()));
var Paragraph = globalStyles/* styled.div */.zo.div(_templateObject4(), function(param) {
    var width = param.width;
    return "calc(100% - ".concat(width, "%)");
}, globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject3()));
var Content = globalStyles/* styled.div */.zo.div(_templateObject5(), utils/* prismicRichText */.C7);
var Photo = globalStyles/* styled.div */.zo.div(_templateObject7(), function(param) {
    var width = param.width;
    return "calc(".concat(width, "%)");
}, globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject6()));

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceContentPhotoText/SliceContentPhotoText.tsx





function SliceContentPhotoText(param) {
    var _slice = param.slice, label = _slice.label, primary = _slice.primary;
    var reverse = label ? label.includes("_-") : true;
    var width = label ? label.slice(0, 2) : 50;
    return primary ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        className: "slice-item blog-text-photo",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Container, {
            reverse: reverse,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Photo, {
                    width: width,
                    children: (primary === null || primary === void 0 ? void 0 : primary.content_photo) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: primary.photo_link ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: primary.photo_link,
                            target: "_blank",
                            rel: "noreferrer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicNextImage/* PrismicNextImage */.Z, {
                                field: primary.content_photo,
                                style: {
                                    maxWidth: "100%",
                                    height: "100%",
                                    margin: "auto"
                                }
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicNextImage/* PrismicNextImage */.Z, {
                            field: primary.content_photo,
                            style: {
                                maxWidth: "100%",
                                height: "100%",
                                margin: "auto"
                            }
                        })
                    })
                }, (0,core/* generateKey */.HI)(primary === null || primary === void 0 ? void 0 : primary.content_text.slice(0, 9), "text-photo__photo")),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                    width: width,
                    children: (primary === null || primary === void 0 ? void 0 : primary.content_text) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                            field: primary === null || primary === void 0 ? void 0 : primary.content_text
                        })
                    })
                }, (0,core/* generateKey */.HI)(primary === null || primary === void 0 ? void 0 : primary.content_text.slice(0, 9), "text-photo__paragraph"))
            ]
        })
    }) : null;
}
SliceContentPhotoText.componentName = "blog-content-text-photo";

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceContentPhotoText/index.tsx



/***/ }),

/***/ 65511:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* reexport */ SliceDownloadFiles; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@prismicio/react/dist/PrismicRichText.js + 16 modules
var PrismicRichText = __webpack_require__(50385);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/@prismic/prismic-config.ts + 31 modules
var prismic_config = __webpack_require__(93092);
;// CONCATENATED MODULE: ./src/images/download_file_icon.svg
var download_file_icon_namespaceObject = __webpack_require__.p + "static/images/download_file_icon.svg";
;// CONCATENATED MODULE: ./src/images/download_file_icon_active.svg
var download_file_icon_active_namespaceObject = __webpack_require__.p + "static/images/download_file_icon_active.svg";
;// CONCATENATED MODULE: ./src/images/download_file_placeholder.svg
var download_file_placeholder_namespaceObject = __webpack_require__.p + "static/images/download_file_placeholder.svg";
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
;// CONCATENATED MODULE: ./src/@next/components/slices/SliceDownloadFiles/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 95px auto 0;\n    max-width: 960px;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 64px auto 0;\n    max-width: 640px;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: relative;\n    margin: 48px auto 0;\n    overflow: hidden;\n    max-width: 85vw;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      display: block;\n      position: absolute;\n      right: 0;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 146px auto 0;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  width: 100%;\n  max-width: 1488px;\n  ",
        "\n  ",
        "\n  ",
        "\n\n  .slice-download-files__categories-list-bg {\n    display: none;\n    ",
        "\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-bottom: 20px;\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 0 0 16px 0;\n    overflow: auto;\n    justify-content: flex-start;\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-bottom: 36px;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-bottom: 1px solid rgba(182, 171, 171, 1);\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      line-height: 100%;\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      white-space: nowrap;\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin-right: 40px;\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin-right: 30px;\n    "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin-right: 20px;\n    "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  opacity: 0.3;\n  transition: opacity 0.25s ease-in-out;\n\n  & > button {\n    font-family: ",
        ";\n    font-size: ",
        ";\n    font-style: normal;\n    font-weight: normal;\n    font-size: 24px;\n    line-height: 100%;\n    color: ",
        ";\n    ",
        "\n    ",
        "\n  }\n\n  &.active,\n  &:hover {\n    opacity: 1;\n  }\n\n  &:not(:last-child) {\n    margin-right: 60px;\n    ",
        "\n    ",
        "\n    ",
        "\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 62px;\n  "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    justify-content: center;\n  "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 40px;\n  "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 110px;\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 60px;\n    width: 440px;\n  "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    max-width: 490px;\n  "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 42px;\n  "
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      align-items: stretch;\n    "
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        margin-right: 20px;\n        height: 72px;\n        width: 72px;\n      "
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        margin-right: 12px;\n        height: 60px;\n        width: 60px;\n      "
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        margin-top: 14px;\n      "
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        margin-top: 4px;\n        display: block;\n      "
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        margin-left: 8px;\n      "
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        margin-left: 0;\n      "
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        height: 50px;\n        width: 50px;\n      "
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        height: 40px;\n        width: 40px;\n      "
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        top: 12px;\n      "
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 80px;\n  width: 584px;\n  ",
        "\n  ",
        "\n  ",
        "\n\n  & > a {\n    display: flex;\n    align-items: center;\n    ",
        "\n\n    &:hover {\n      .tab-item__icon-img--active {\n        opacity: 1;\n      }\n    }\n  }\n\n  .tab-item {\n    &__prev-img {\n      margin-right: 30px;\n      border-radius: 4px;\n\n      ",
        "\n      ",
        "\n    }\n\n    &__text-wr {\n      display: flex;\n      justify-content: space-between;\n      flex: 1 0 0;\n    }\n\n    &__title * {\n      font-family: ",
        ";\n      font-size: ",
        ";\n      font-style: normal;\n      font-weight: normal;\n      font-size: 30px;\n      line-height: 110%;\n      display: flex;\n      align-items: center;\n      color: #000000;\n    }\n\n    &__description {\n      margin-top: 17px;\n      display: flex;\n      ",
        "\n      ",
        "\n\n      & * {\n        font-family: ",
        ";\n        font-size: ",
        ";\n        font-style: normal;\n        font-weight: normal;\n        line-height: 160%;\n        color: ",
        ";\n      }\n    }\n\n    &__size {\n      margin-left: 15px;\n      font-family: ",
        ";\n      font-size: ",
        ";\n      font-style: normal;\n      font-weight: normal;\n      line-height: 160%;\n      white-space: nowrap;\n      color: ",
        ";\n      opacity: 0.5;\n      ",
        "\n      ",
        "\n    }\n\n    &__icon-img {\n      ",
        "\n      ",
        "\n\n      &--active {\n        position: absolute;\n        opacity: 0;\n        transition: opacity 0.25s ease-in-out;\n      }\n    }\n\n    &__icon-wr {\n      position: relative;\n      top: 15px;\n      ",
        "\n    }\n  }\n"
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}

var Wrapper = globalStyles/* styled.div */.zo.div(_templateObject4(), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject()), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject1()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject2()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject3()));
var TabList = globalStyles/* styled.ul */.zo.ul(_templateObject7(), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject5()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject6()));
var TabElement = globalStyles/* styled.li */.zo.li(_templateObject13(), function(props) {
    return props.theme.typography.thinFontFamily;
}, function(props) {
    return props.theme.typography.baseFontSize;
}, function(props) {
    return props.theme.colors.baseFont;
}, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject8()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject9()), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject10()), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject11()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject12()));
var TabPanel = globalStyles/* styled.ul */.zo.ul(_templateObject17(), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject14()), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject15()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject16()));
var TabItem = globalStyles/* styled.li */.zo.li(_templateObject31(), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject18()), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject19()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject20()), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject21()), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject22()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject23()), function(props) {
    return props.theme.typography.thinFontFamily;
}, function(props) {
    return props.theme.typography.h4FontSize;
}, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject24()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject25()), function(props) {
    return props.theme.typography.extraFontFamily;
}, function(props) {
    return props.theme.typography.smallFontSize;
}, function(props) {
    return props.theme.colors.baseFont;
}, function(props) {
    return props.theme.typography.extraFontFamily;
}, function(props) {
    return props.theme.typography.smallFontSize;
}, function(props) {
    return props.theme.colors.graySemi;
}, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject26()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject27()), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject28()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject29()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject30()));

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceDownloadFiles/SliceDownloadFiles.tsx









function compareStrings(str1, str2) {
    if (str1 === null || str2 === null) {
        return false;
    }
    return str1.toLowerCase().replace(" ", "") === str2.toLowerCase().replace(" ", "");
}
function SliceDownloadFiles(param) {
    var fields = param.slice.fields;
    var initialFilesState = {};
    var ref = (0,react.useState)(initialFilesState), files = ref[0], setFiles = ref[1];
    var ref1 = (0,react.useState)(""), currentCategory = ref1[0], setCurrentCategory = ref1[1];
    (0,react.useEffect)(function() {
        var categoriesList = (0,_to_consumable_array/* default */.Z)(new Set(fields.map(function(item) {
            return item.filecategory;
        }).filter(function(item) {
            return item !== null;
        })));
        var structuredFiles = {};
        categoriesList.forEach(function(cat) {
            if (!cat) {
                return;
            }
            structuredFiles[cat] = fields.filter(function(item) {
                return compareStrings(item.filecategory, cat);
            });
        });
        setFiles(structuredFiles);
        if (categoriesList.length > 0) {
            setCurrentCategory(categoriesList[0]);
        }
    }, []);
    var setActiveCategory = function(category) {
        setCurrentCategory(category);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        className: "slice-item slice-download-files",
        children: currentCategory && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                Object.keys(files) && /*#__PURE__*/ (0,jsx_runtime.jsx)(TabList, {
                    className: "slice-download-files__categories-list",
                    children: Object.keys(files).map(function(category) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TabElement, {
                            className: compareStrings(currentCategory, category) ? "slice-download-files__category active" : "slice-download-files__category",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                onClick: function() {
                                    return setActiveCategory(category);
                                },
                                type: "button",
                                children: category
                            })
                        }, "slice-download-files__category_".concat(category));
                    })
                }),
                files[currentCategory] && /*#__PURE__*/ (0,jsx_runtime.jsx)(TabPanel, {
                    className: "slice-download-files__tab-panel",
                    children: files[currentCategory].map(function(item, i) {
                        var _link = item.filelink;
                        if (!_link) {
                            return null;
                        }
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TabItem, {
                            className: "slice-download-files__tab-item",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                href: (0,prismic_config/* linkResolver */.kG)(_link),
                                download: "FileName",
                                target: "_blank",
                                rel: "noreferrer",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "tab-item__prev-img",
                                        src: item.filelogo ? item.filelogo.url : download_file_placeholder_namespaceObject,
                                        alt: item.filelogo ? item.filelogo.alt : "download file"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "tab-item__text-wr",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    item.filetitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "tab-item__title",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                                                            field: item.filetitle
                                                        })
                                                    }),
                                                    item.filedescription && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "tab-item__description",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                                                                field: item.filedescription
                                                            }),
                                                            (_link === null || _link === void 0 ? void 0 : _link.size) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "tab-item__size",
                                                                children: [
                                                                    Math.floor(((_link === null || _link === void 0 ? void 0 : _link.size) || 0) / 1024),
                                                                    " kb"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "tab-item__icon-wr",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        className: "tab-item__icon-img tab-item__icon-img--active",
                                                        src: download_file_icon_active_namespaceObject,
                                                        alt: ""
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        className: "tab-item__icon-img",
                                                        src: download_file_icon_namespaceObject,
                                                        alt: ""
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, "".concat(i));
                    })
                })
            ]
        })
    });
}
SliceDownloadFiles.componentName = "download-files";

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceDownloadFiles/index.ts



/***/ }),

/***/ 43539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V": function() { return /* reexport */ SliceExerpt; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
;// CONCATENATED MODULE: ./src/@next/components/slices/SliceExerpt/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 640px;\n    width: 50vw;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 520px;\n    width: 68vw;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 85vw;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 45vw;\n  max-width: 860px;\n  margin: 0 auto;\n\n  ",
        "\n  ",
        "\n  ",
        "\n\n  p {\n    font-family: ",
        ";\n    font-size: ",
        ";\n    font-weight: 500;\n    font-size: 20px;\n    line-height: 180%;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var Wrapper = globalStyles/* styled.div */.zo.div(_templateObject3(), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject()), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject1()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject2()), function(props) {
    return props.theme.typography.extraFontFamily;
}, function(props) {
    return props.theme.typography.baseFontSize;
});

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceExerpt/SliceExerpt.tsx


function SliceExerpt(param) {
    var primary = param.slice.primary;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        className: "slice-item slice-exerpt",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            children: primary === null || primary === void 0 ? void 0 : primary.text
        })
    });
}
SliceExerpt.componentName = "excerpt";

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceExerpt/index.ts



/***/ }),

/***/ 77659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I": function() { return /* reexport */ SliceFormEmbded; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
// EXTERNAL MODULE: ./src/@next/components/templates/Container/index.ts
var Container = __webpack_require__(95213);
;// CONCATENATED MODULE: ./src/@next/components/slices/SliceFormEmbded/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      min-height: 542px;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      min-height: 480px;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      min-height: 380px;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  iframe {\n    width: 100%;\n    min-height: 840px;\n    ",
        "\n    ",
        "\n    ",
        "\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var Wrapper = (0,globalStyles/* styled */.zo)(Container/* Container */.W2)(_templateObject3(), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject()), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject1()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject2()));

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceFormEmbded/SliceFormEmbded.tsx


function SliceFormEmbded(param) {
    var primary = param.slice.primary;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        id: "slice-form-embded",
        className: "slice-item slice-form-embded",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
            title: "typeform-embed",
            src: (ref = primary === null || primary === void 0 ? void 0 : primary.embded_link) === null || ref === void 0 ? void 0 : ref.url
        })
    });
}
SliceFormEmbded.componentName = "formembded";

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceFormEmbded/index.tsx



/***/ }),

/***/ 75386:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* reexport */ SliceHeroImg; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next-translate-routes/link.js
var next_translate_routes_link = __webpack_require__(73966);
var link_default = /*#__PURE__*/__webpack_require__.n(next_translate_routes_link);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
;// CONCATENATED MODULE: ./src/@next/components/slices/SliceHeroImg/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 860px;\n    width: 72vw;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 640px;\n    width: 85vw;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 63vw;\n  max-width: 1200px;\n  margin: 0 auto;\n\n  ",
        "\n  ",
        "\n\n  img {\n    width: 100%;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var Wrapper = globalStyles/* styled.div */.zo.div(_templateObject2(), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject()), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject1()));

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceHeroImg/SliceHeroImg.tsx



function SliceHeroImg(param) {
    var primary = param.slice.primary;
    var ref;
    var img = /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        src: (primary === null || primary === void 0 ? void 0 : (ref = primary.img) === null || ref === void 0 ? void 0 : ref.url) || "",
        alt: "icon"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        className: "slice-item slice-hero-img",
        children: (primary === null || primary === void 0 ? void 0 : primary.hero_image_link) ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: primary === null || primary === void 0 ? void 0 : primary.hero_image_link,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                target: "_blank",
                rel: "noreferrer",
                children: img
            })
        }) : img
    });
}
SliceHeroImg.componentName = "heroimg";

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceHeroImg/index.ts



/***/ }),

/***/ 18789:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* reexport */ SliceHtmlEmbded; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@prismicio/richtext/dist/asText.js
var asText = __webpack_require__(98268);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
// EXTERNAL MODULE: ./src/@next/components/templates/Container/index.ts
var Container = __webpack_require__(95213);
// EXTERNAL MODULE: ./src/@next/globalStyles/utils.ts + 1 modules
var utils = __webpack_require__(44610);
;// CONCATENATED MODULE: ./src/@next/components/slices/SliceHtmlEmbded/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Wrapper = (0,globalStyles/* styled */.zo)(Container/* Container */.W2)(_templateObject(), utils/* prismicRichText */.C7);

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceHtmlEmbded/SliceHtmlEmbded.tsx



function SliceHtmlEmbded(param) {
    var primary = param.slice.primary;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        className: "slice-item slice-html-embded",
        dangerouslySetInnerHTML: {
            __html: asText/* asText */.S(primary.html)
        }
    });
}
SliceHtmlEmbded.componentName = "htmlembded";

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceHtmlEmbded/index.tsx



/***/ }),

/***/ 719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* reexport */ SliceIconBanner; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next-translate-routes/link.js
var next_translate_routes_link = __webpack_require__(73966);
var link_default = /*#__PURE__*/__webpack_require__.n(next_translate_routes_link);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./src/@next/hooks/useMediaQuery/index.ts + 3 modules
var useMediaQuery = __webpack_require__(15996);
// EXTERNAL MODULE: ./src/@next/globalStyles/constants.ts
var constants = __webpack_require__(38408);
// EXTERNAL MODULE: ./src/@prismic/prismic-config.ts + 31 modules
var prismic_config = __webpack_require__(93092);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
// EXTERNAL MODULE: ./src/@next/components/templates/Container/index.ts
var Container = __webpack_require__(95213);
;// CONCATENATED MODULE: ./src/@next/components/slices/SliceIconBanner/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  .slick-slide {\n    .slice-icon-banner__list-item {\n      display: inline-flex !important;\n      justify-content: center;\n      align-items: center;\n      margin: 0;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 30px;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 40px;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: 160%;\n  margin-bottom: 50px;\n  color: ",
        ";\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex-direction: column;\n    align-items: flex-start;\n    margin: 0 0 -53px;\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  margin: 0 -20px -53px;\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 0 0 53px;\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      height: 70px;\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      height: 50px;\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin-left: 32px;\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin-left: 24px;\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-flex;\n  align-items: center;\n  margin: 0 20px 53px;\n  ",
        "\n  img {\n    height: 90px;\n    flex-shrink: 0;\n    ",
        "\n    ",
        "\n  }\n  span {\n    font-family: ",
        ";\n    font-size: ",
        ";\n    line-height: 130%;\n    margin-left: 45px;\n    width: auto;\n    max-width: 293px;\n    ",
        "\n    ",
        "\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}


var Wrapper = (0,globalStyles/* styled */.zo)(Container/* Container */.W2)(_templateObject());
var Title = globalStyles/* styled.div */.zo.div(_templateObject3(), function(props) {
    return props.theme.typography.extraFontFamily;
}, function(props) {
    return props.theme.typography.smallFontSize;
}, function(props) {
    return props.theme.colors.graySemi;
}, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject1()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject2()));
var List = globalStyles/* styled.div */.zo.div(_templateObject5(), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject4()));
var Item = globalStyles/* styled.div */.zo.div(_templateObject11(), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject6()), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject7()), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject8()), function(props) {
    return props.theme.typography.thinFontFamily;
}, function(props) {
    return props.theme.typography.h4FontSize;
}, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject9()), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject10()));

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceIconBanner/SliceIconBanner.tsx










var sliderSettings = {
    arrows: false,
    autoplay: false,
    dots: false,
    infinite: true,
    slidesToScroll: 1,
    slidesToShow: 1,
    speed: 1000
};
function SliceIconBanner(param) {
    var _slice = param.slice, primary = _slice.primary, fields = _slice.fields;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useMediaQuery/* useMediaQuery */.a)("(max-width: ".concat(constants/* smallScreen */.xC, "px)")), 1), isSmallScreen = ref[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        className: "slice-item slice-icon-banner",
        children: [
            (primary === null || primary === void 0 ? void 0 : primary.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                className: "slice-icon-banner__title",
                children: primary === null || primary === void 0 ? void 0 : primary.title
            }),
            isSmallScreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sliderSettings), {
                children: fields === null || fields === void 0 ? void 0 : fields.map(function(item, i) {
                    var title = item.title, img = item.img;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                        as: "div",
                        className: "slice-icon-banner__list-item",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: (img === null || img === void 0 ? void 0 : img.url) || "",
                                alt: "icon"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                dangerouslySetInnerHTML: {
                                    __html: (title === null || title === void 0 ? void 0 : title.replace(/\n/, "<br/>")) || ""
                                }
                            })
                        ]
                    }, "slice-icon-banner-".concat(i));
                })
            })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: Boolean(fields.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(List, {
                    className: "slice-icon-banner__list",
                    children: fields === null || fields === void 0 ? void 0 : fields.map(function(item, i) {
                        var title = item.title, img = item.img;
                        var _link = item === null || item === void 0 ? void 0 : item.link;
                        if (item.link) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: (0,prismic_config/* linkResolver */.kG)(_link),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                                    as: "a",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: (img === null || img === void 0 ? void 0 : img.url) || "",
                                            alt: "icon"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            dangerouslySetInnerHTML: {
                                                __html: (title === null || title === void 0 ? void 0 : title.replace(/\n/, "<br/>")) || ""
                                            }
                                        })
                                    ]
                                })
                            }, "slice-icon-banner-".concat(i));
                        }
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                            as: "li",
                            className: "slice-icon-banner__list-item",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: (img === null || img === void 0 ? void 0 : img.url) || "",
                                    alt: "icon"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    dangerouslySetInnerHTML: {
                                        __html: (title === null || title === void 0 ? void 0 : title.replace(/\n/, "<br/>")) || ""
                                    }
                                })
                            ]
                        }, "slice-icon-banner-".concat(i));
                    })
                })
            })
        ]
    });
}
SliceIconBanner.componentName = "iconbanner";

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceIconBanner/index.ts



/***/ }),

/***/ 37505:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "B": function() { return /* reexport */ SliceIconCta; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
// EXTERNAL MODULE: ./node_modules/next-translate-routes/link.js
var next_translate_routes_link = __webpack_require__(73966);
var link_default = /*#__PURE__*/__webpack_require__.n(next_translate_routes_link);
// EXTERNAL MODULE: ./src/@next/components/atoms/Button/index.ts + 2 modules
var Button = __webpack_require__(45506);
// EXTERNAL MODULE: ./src/@prismic/prismic-config.ts + 31 modules
var prismic_config = __webpack_require__(93092);
// EXTERNAL MODULE: ./src/intl.ts
var src_intl = __webpack_require__(72110);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
// EXTERNAL MODULE: ./src/@next/components/templates/Container/index.ts
var Container = __webpack_require__(95213);
;// CONCATENATED MODULE: ./src/@next/components/slices/SliceIconCta/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    // max-width: 940px;\n    // width: 74vw;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex-direction: column;\n    max-width: 350px;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 272px;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin: 0 auto;\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 250px;\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      line-height: 13px;\n      margin-top: 36px;\n      width: 220px;\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin-top: 42px;\n      width: 100%;\n      max-width: 246px;\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  ",
        "\n  ",
        "\n\n  img {\n    width: 100%;\n  }\n\n  a {\n    font-family: ",
        ";\n    font-size: ",
        ";\n    margin-top: 55px;\n    line-height: 18px;\n    text-transform: uppercase;\n    width: 280px;\n    text-align: center;\n    ",
        "\n    ",
        "\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 40px;\n  "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 20px;\n  "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: 140%;\n  margin-top: 60px;\n  text-align: center;\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 1px;\n    margin-top: 50px;\n    margin-bottom: 50px;\n  "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 25px;\n    margin-bottom: 25px;\n  "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 1px;\n  margin-left: auto;\n  margin-right: auto;\n  background-color: ",
        ";\n  opacity: 0.15;\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}


var Wrapper = (0,globalStyles/* styled */.zo)(Container/* Container */.W2)(_templateObject3(), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject()), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject1()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject2()));
var Item = globalStyles/* styled.div */.zo.div(_templateObject8(), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject4()), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject5()), function(props) {
    return props.theme.typography.boldFontFamily;
}, function(props) {
    return props.theme.typography.baseFontSize;
}, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject6()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject7()));
var ItemTitle = globalStyles/* styled.span */.zo.span(_templateObject11(), function(props) {
    return props.theme.typography.thinFontFamily;
}, function(props) {
    return props.theme.typography.h4FontSize;
}, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject9()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject10()));
var Separator = globalStyles/* styled.div */.zo.div(_templateObject14(), function(props) {
    return props.theme.colors.secondary;
}, globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject12()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject13()));

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceIconCta/SliceIconCta.tsx








function SliceIconCta(param) {
    var fields = param.slice.fields;
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        className: "slice-item slice-icon-cta",
        children: Boolean(fields.length) && fields.map(function(z, i) {
            var title = z.title, link = z.link, img = z.img;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                        className: "slice-icon-cta__item",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: img === null || img === void 0 ? void 0 : img.url,
                                alt: "Img"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemTitle, {
                                children: title
                            }),
                            (link === null || link === void 0 ? void 0 : link.__typename) === "_FileLink" && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: link === null || link === void 0 ? void 0 : link.url,
                                download: link === null || link === void 0 ? void 0 : link.name,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                    fullWidth: true,
                                    children: intl.formatMessage(src_intl/* commonMessages.download */.i4.download)
                                })
                            }),
                            !((link === null || link === void 0 ? void 0 : link.__typename) === "_FileLink") && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: (0,prismic_config/* linkResolver */.kG)(link),
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* ButtonLink */.Z, {
                                    fullWidth: true,
                                    children: intl.formatMessage(src_intl/* commonMessages.showMore */.i4.showMore)
                                })
                            })
                        ]
                    }),
                    i + 1 < fields.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(Separator, {
                        className: "slice-icon-cta__separator"
                    })
                ]
            }, "slice-icon-cta__item_".concat(i));
        })
    });
}
SliceIconCta.componentName = "iconcta";

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceIconCta/index.ts



/***/ }),

/***/ 18761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* reexport */ SliceMediaSlider; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(52015);
// EXTERNAL MODULE: ./src/images/chevron_left.svg
var chevron_left = __webpack_require__(36811);
// EXTERNAL MODULE: ./src/images/chevron_right.svg
var chevron_right = __webpack_require__(81111);
;// CONCATENATED MODULE: ./src/@next/components/slices/SliceMediaSlider/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      width: 50px;\n      height: 50px;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      display: none !important;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .slick-arrow {\n    width: 56px;\n    height: 56px;\n    z-index: 3;\n    color: transparent;\n    background-color: #fff;\n    box-shadow: 0px 4px 34px rgba(0, 0, 0, 0.08);\n    border-radius: 50%;\n    position: absolute;\n    transform: translateY(-50%);\n    ",
        "\n    ",
        "\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      left: -71px;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      left: -82px;\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .slick-prev {\n    background: url(",
        ") no-repeat center !important;\n    background-size: contain;\n    left: -120px;\n    top: 50%;\n    ",
        "\n    ",
        "\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      right: -71px;\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      right: -82px;\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .slick-next {\n    background: url(",
        ") no-repeat center !important;\n    background-size: contain;\n    right: -120px;\n    top: 50%;\n    ",
        "\n    ",
        "\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 54vw;\n    max-width: 690px;\n  "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 62vw;\n    max-width: 476px;\n  "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 360px;\n    width: 85vw;\n  "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 50vw;\n  max-width: 960px;\n  margin: 0 auto;\n  position: relative;\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding-top: 60%;\n  position: relative;\n  video {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    width: 100%;\n    height: 100%;\n    transform: translate(-50%, -50%);\n    object-fit: contain;\n    background-color: #000000;\n  }\n  img {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    width: 100%;\n    height: 100%;\n    transform: translate(-50%, -50%);\n    object-fit: cover;\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}




var slickArrow = (0,styled_components_browser_esm/* css */.iv)(_templateObject2(), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject1()));
var slickPrev = (0,styled_components_browser_esm/* css */.iv)(_templateObject5(), chevron_left, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject3()), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject4()));
var slickNext = (0,styled_components_browser_esm/* css */.iv)(_templateObject8(), chevron_right, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject6()), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject7()));
var Wrapper = globalStyles/* styled.div */.zo.div(_templateObject12(), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject9()), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject10()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject11()), slickArrow, slickPrev, slickNext);
var Item = globalStyles/* styled.div */.zo.div(_templateObject13());

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceMediaSlider/SliceMediaSlider.tsx
/* eslint-disable jsx-a11y/media-has-caption */ 




var sliderSettings = {
    arrows: true,
    autoplay: false,
    dots: false,
    infinite: true,
    slidesToScroll: 1,
    slidesToShow: 1,
    speed: 1000
};
function SliceMediaSlider(param) {
    var fields = param.slice.fields;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        className: "slice-item slice-media-slider",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sliderSettings), {
            children: fields === null || fields === void 0 ? void 0 : fields.map(function(item, i) {
                var media = item.media, media_type = item.media_type;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                    className: "slice-media-slider__item",
                    children: [
                        media_type === "video" && /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                            controls: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                src: media.url
                            })
                        }),
                        media_type === "img" && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: media.url,
                            alt: "Img"
                        })
                    ]
                }, "slide_item_".concat(i));
            })
        }))
    });
}
SliceMediaSlider.componentName = "mediaslider";

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceMediaSlider/index.ts



/***/ }),

/***/ 29848:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I": function() { return /* reexport */ SliceOurPartners; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@prismicio/react/dist/PrismicRichText.js + 16 modules
var PrismicRichText = __webpack_require__(50385);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
// EXTERNAL MODULE: ./src/@next/components/templates/Container/index.ts
var Container = __webpack_require__(95213);
;// CONCATENATED MODULE: ./src/@next/components/slices/SliceOurPartners/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 207px;\n    width: 75vw;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 142px;\n    flex-direction: column;\n    align-items: center;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 120px;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 85vw;\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 240px;\n  display: flex;\n\n  margin-top: 240px;\n  display: flex;\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 69px;\n    margin-right: 5.78vw;\n    font-size: 16px;\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 100%;\n    margin-right: 0;\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 78px;\n  margin-right: 9.8vw;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-style: normal;\n  font-weight: normal;\n  line-height: 160%;\n  color: ",
        ";\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex-wrap: wrap;\n    justify-content: center;\n  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 48px;\n\n    &:not(:last-child) {\n      margin-right: 3.75vw;\n    }\n  "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 37px;\n    height: 37px;\n\n    &:not(:last-child) {\n      margin-right: 4.82vw;\n    }\n  "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 36px;\n\n    &:not(:last-child) {\n      margin-right: 7.375vw;\n    }\n\n    &:nth-child(3n) {\n      margin-right: 0;\n    }\n  "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      max-width: 120px;\n    "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      max-width: 96px;\n    "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      max-width: 90px;\n    "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 60px;\n\n  &:not(:last-child) {\n    margin-right: 4.6875vw;\n  }\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n\n  img {\n    max-height: 100%;\n    position: relative;\n    top: 50%;\n    transform: translateY(-50%);\n\n    ",
        "\n\n    ",
        "\n\n    ",
        "\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}


var Wrapper = (0,globalStyles/* styled */.zo)(Container/* Container */.W2)(_templateObject4(), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject()), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject1()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject2()), globalStyles/* media.xSmallScreen */.BC.xSmallScreen(_templateObject3()));
var Title = globalStyles/* styled.div */.zo.div(_templateObject7(), function(props) {
    return props.theme.typography.boldFontFamily;
}, function(props) {
    return props.theme.typography.baseFontSize;
}, function(props) {
    return props.theme.colors.baseFont;
}, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject5()), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject6()));
var List = globalStyles/* styled.ul */.zo.ul(_templateObject9(), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject8()));
var Item = globalStyles/* styled.li */.zo.li(_templateObject16(), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject10()), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject11()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject12()), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject13()), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject14()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject15()));

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceOurPartners/SliceOurPartners.tsx



function SliceOurPartners(param) {
    var _slice = param.slice, primary = _slice.primary, fields = _slice.fields;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        className: "slice-item slice-our-partners",
        children: [
            primary && (primary === null || primary === void 0 ? void 0 : primary.our_partners_title[0].text) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                className: "slice-our-partners__title",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                    field: primary.our_partners_title
                })
            }),
            fields && /*#__PURE__*/ (0,jsx_runtime.jsx)(List, {
                className: "slice-our-partners__icons-list",
                children: fields.map(function(param, i) {
                    var logo_image = param.logo_image;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                        className: "slice-our-partners__icon",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: logo_image.url,
                            alt: ""
                        })
                    }, "slice-our-partners__icon_".concat(i));
                })
            })
        ]
    });
}
SliceOurPartners.componentName = "our_partners";

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceOurPartners/index.ts



/***/ }),

/***/ 67293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I": function() { return /* reexport */ SliceQuote; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/images/quote.svg
var quote_namespaceObject = __webpack_require__.p + "static/images/quote.svg";
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
;// CONCATENATED MODULE: ./src/@next/components/slices/SliceQuote/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 57vw;\n    max-width: 720px;\n    padding: 40px 50px;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 640px;\n    width: 85vw;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 24px 0 24px 39px;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      top: 50px;\n      width: 18px;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      top: 33px;\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 52vw;\n  max-width: 1000px;\n  margin: 0 auto;\n  padding: 50px;\n  border-top: 1px solid #e6e9ea;\n  border-bottom: 1px solid #e6e9ea;\n  position: relative;\n\n  ",
        "\n  ",
        "\n  ",
        "\n\n  img {\n    position: absolute;\n    left: 0;\n    top: 58px;\n    width: 21px;\n\n    ",
        "\n    ",
        "\n  }\n\n  p {\n    font-family: ",
        ";\n    font-size: ",
        ";\n    font-family: 'Inter';\n    font-weight: 500;\n    line-height: 180%;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}

var Wrapper = globalStyles/* styled.div */.zo.div(_templateObject5(), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject()), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject1()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject2()), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject3()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject4()), function(props) {
    return props.theme.typography.extraFontFamily;
}, function(props) {
    return props.theme.typography.baseFontSize;
});

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceQuote/SliceQuote.tsx



function SliceQuote(param) {
    var primary = param.slice.primary;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        className: "slice-item slice-quote",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: quote_namespaceObject,
                alt: "Icon"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: primary === null || primary === void 0 ? void 0 : primary.quote
            })
        ]
    });
}
SliceQuote.componentName = "quote";

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceQuote/index.ts



/***/ }),

/***/ 34912:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c": function() { return /* reexport */ SliceRichText; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@prismicio/react/dist/PrismicRichText.js + 16 modules
var PrismicRichText = __webpack_require__(50385);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
// EXTERNAL MODULE: ./src/@next/components/templates/Container/index.ts
var Container = __webpack_require__(95213);
// EXTERNAL MODULE: ./src/@next/globalStyles/utils.ts + 1 modules
var utils = __webpack_require__(44610);
;// CONCATENATED MODULE: ./src/@next/components/slices/SliceRichText/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Wrapper = (0,globalStyles/* styled */.zo)(Container/* Container */.W2)(_templateObject(), utils/* prismicRichText */.C7);

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceRichText/SliceRichText.tsx



function SliceRichText(param) {
    var primary = param.slice.primary;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        className: "slice-item slice-rich-text ".concat(primary.classes ? primary.classes : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
            field: primary.rich_text
        })
    });
}
SliceRichText.componentName = "richtext";

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceRichText/index.ts



/***/ }),

/***/ 88329:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* reexport */ SliceTagImage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
;// CONCATENATED MODULE: ./src/@next/components/slices/SliceTagImage/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 860px;\n    width: 72vw;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 640px;\n    width: 85vw;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 360px;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 63vw;\n  max-width: 1200px;\n  margin: 0 auto;\n\n  ",
        "\n  ",
        "\n  ",
        "\n\n  img {\n    max-width: 100%;\n    height: auto;\n    margin-left: auto;\n    margin-right: auto;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: none;\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: block;\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 12px;\n  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 14px;\n  "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-style: italic;\n  color: ",
        ";\n  opacity: 0.7;\n  line-height: 180%;\n  text-align: center;\n  margin-top: 20px;\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}

var Wrapper = globalStyles/* styled.div */.zo.div(_templateObject3(), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject()), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject1()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject2()));
var DesktopImage = globalStyles/* styled.img */.zo.img(_templateObject5(), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject4()));
var MobileImage = globalStyles/* styled.img */.zo.img(_templateObject7(), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject6()));
var SubTitle = globalStyles/* styled.div */.zo.div(_templateObject10(), function(props) {
    return props.theme.typography.extraFontFamily;
}, function(props) {
    return props.theme.typography.smallFontSize;
}, function(props) {
    return props.theme.colors.graySemi;
}, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject8()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject9()));

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceTagImage/SliceTagImage.tsx




function SliceTagImage(param) {
    var _slice = param.slice, primary = _slice.primary, fields = _slice.fields;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        className: "slice-item slice-tag-image",
        children: [
            fields.map(function(item, i) {
                var ref, ref1, ref2, ref3;
                var imgStyles = {
                    height: item && item.image_height ? "".concat(item.image_height, "px") : "auto",
                    width: item && item.image_width ? "".concat(item.image_width, "px") : "auto"
                };
                var imgMobile = (item === null || item === void 0 ? void 0 : item.imgmobile) && /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileImage, {
                    className: "slice-tag-image__mobile",
                    src: (item === null || item === void 0 ? void 0 : (ref = item.imgmobile) === null || ref === void 0 ? void 0 : ref.url) || "",
                    alt: "icon",
                    width: (item === null || item === void 0 ? void 0 : (ref1 = item.imgmobile) === null || ref1 === void 0 ? void 0 : ref1.dimensions.width) || "auto",
                    style: (0,_object_spread/* default */.Z)({}, imgStyles)
                }) || null;
                var img = (item === null || item === void 0 ? void 0 : item.img) && /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopImage, {
                    className: "slice-tag-image__desktop",
                    src: (item === null || item === void 0 ? void 0 : (ref2 = item.img) === null || ref2 === void 0 ? void 0 : ref2.url) || "",
                    alt: "icon",
                    width: (item === null || item === void 0 ? void 0 : (ref3 = item.img) === null || ref3 === void 0 ? void 0 : ref3.dimensions.width) || "auto",
                    style: (0,_object_spread/* default */.Z)({}, imgStyles)
                }) || null;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        (item === null || item === void 0 ? void 0 : item.tag_image_link) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: item === null || item === void 0 ? void 0 : item.tag_image_link,
                            target: "_blank",
                            rel: "noreferrer",
                            children: img
                        }) : img,
                        (item === null || item === void 0 ? void 0 : item.tag_image_link) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: item === null || item === void 0 ? void 0 : item.tag_image_link,
                            target: "_blank",
                            rel: "noreferrer",
                            children: imgMobile
                        }) : imgMobile
                    ]
                }, "slice-tag-image-".concat(i));
            }),
            (primary === null || primary === void 0 ? void 0 : primary.subtitle) && /*#__PURE__*/ (0,jsx_runtime.jsx)(SubTitle, {
                className: "slice-tag-image__subtitle",
                children: primary === null || primary === void 0 ? void 0 : primary.subtitle
            })
        ]
    });
}
SliceTagImage.componentName = "tagimage";

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceTagImage/index.ts



/***/ })

}]);